// System dependencies

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Application dependencies

import { FormSpinnerFields, FormSpinnerRedux } from '@/interfaces/formSpinner.interfaces';
import { RootState } from '@/redux/store';

// State

const initialState: FormSpinnerRedux = {
  [FormSpinnerFields.Caption]: null,
  [FormSpinnerFields.IsActive]: false,
  [FormSpinnerFields.StartTime]: null,
};

// Slices

const formSpinnerSlice = createSlice({
  name: 'formSpinner',
  initialState: initialState,
  reducers: {
    activateFormSpinner: (state, action: PayloadAction<{ caption: string }>) => {
      state[FormSpinnerFields.Caption] = action.payload[FormSpinnerFields.Caption] || null;
      state[FormSpinnerFields.IsActive] = true;
      state[FormSpinnerFields.StartTime] = Date.now();
    },
    deactivateFormSpinner: (state) => {
      state[FormSpinnerFields.Caption] = null;
      state[FormSpinnerFields.IsActive] = false;
      state[FormSpinnerFields.StartTime] = null;
    },
  },
});

// Exports

export const { activateFormSpinner, deactivateFormSpinner } = formSpinnerSlice.actions;

export const getFormSpinnerSelector = (state: RootState) => state.formSpinner;

export default formSpinnerSlice.reducer;
